<template>
  <WsCreateBatchFromParagraph
    ref="WsCreateBatchFromParagraph"
    localeMode
    compareMode
    contentLabel="內文"
    titleLabel="條文文字"
    preTitleLabel="章節文字"
    compareTitleFirst="官網版本"
    compareTitleSecond="比對版本"
    :label="label"
    :modelName="modelName"
    :backRoute="_backRoute"
    :someFields="someFields"
    :parseFields="parseFields"
    :someFieldsValue="someFieldsValue"
    @submit="$_onSubmit($event)"
    @someFieldsValue="$_onSetSomeFieldsValue($event)"
  />
</template>

<script>
import model from '@/models/article';
import parentmodel from '@/models/act';

export default {
  data() {
    return {
      someFieldsValue: {},
      modelName: model.modelName,
      parentModelName: parentmodel.modelName,
      label: model.label,
      parentModelData: {},
      parseFields: model.parseFields,
      someFields: {
        announce_at: {
          type: 'date',
          label: '發布日期',
          maxlength: 100,
          sm: 4,
        },
        effect_at: {
          type: 'date',
          label: '生效日期',
          rules: 'required',
          maxlength: 100,
          sm: 4,
        },
        reference_link: {
          type: 'link',
          label: '來源連結',
          sm: 4,
          maxlength: 500,
        },
      },
      total: 0,
    };
  },
  computed: {
    _id() {
      return this.$route.params.id;
    },
    _parentVersionId() {
      if (this.$route.params.version_id) return this.$route.params.version_id;
      return this.parentModelData.last_version.id;
    },
    _backRoute() {
      if (this.$route.query && this.$route.query.redirect) {
        return this.$route.query.redirect;
      } else {
        return `/${this.modelName}`;
      }
    },
  },
  async mounted() {
    this.$_getSomeFieldsKey();
    await this.$_fetchData();
  },
  methods: {
    async $_onSubmit($event) {
      this.$refs.WsCreateBatchFromParagraph.loadingStart();
      const submitArr = $event.submitArr ? $event.submitArr : null;
      const locale = $event.locale ? $event.locale : null;
      const datas = [];
      submitArr.forEach((submitItem) => {
        datas.push({
          is_active: true,
          versions: [
            {
              locales: {
                [locale]: this.$_setLocalesData(submitItem),
              },
            },
          ],
        });
        if (this.someFieldsValue) {
          this.$set(
            datas[datas.length - 1].versions[datas[datas.length - 1].versions.length - 1],
            'no_number',
            `${datas.length + this.total}`.padStart(4, '0') + '-00',
          );
          this.$set(
            datas[datas.length - 1].versions[datas[datas.length - 1].versions.length - 1],
            'act_status',
            1,
          );
          this.$_CMS_updateDataSetFromFields(
            this,
            datas[datas.length - 1].versions[datas[datas.length - 1].versions.length - 1],
            this.someFields,
          );
          for (let fieldKey in this.someFieldsValue) {
            datas[datas.length - 1].versions[datas[datas.length - 1].versions.length - 1][
              fieldKey
            ] = this.someFieldsValue[fieldKey];
          }
        }
      });
      try {
        const dataLength = datas.length;
        const apiTimes = Math.ceil(dataLength / 50);
        const url = `/act_version/${this._parentVersionId}/article/batch`;
        for (let i = 0; i < apiTimes; i++) {
          const endIndex = i === apiTimes - 1 ? dataLength : 50 * (i + 1);
          const _datas = datas.slice(50 * i, endIndex);
          await this.$axios.post(url, { datas: _datas });
          if (i !== 0 && i < apiTimes - 1) {
            await new Promise((resolve) => setTimeout(resolve, 3000));
          }
        }
        this.$_navigateAfterBatch();
      } catch (error) {
        console.error('$_onSubmit failed', error);
        alert(
          '批次上傳錯誤，但可能已經上傳部分法條，請回到法規內頁，確認目前有哪些法條尚未上傳，再繼續進行批次上傳',
        );
        this.$_navigateAfterBatch();
      } finally {
        this.$refs.WsCreateBatchFromParagraph.loadingStop();
      }
    },
    $_navigateAfterBatch() {
      const redirectUrl = this.$route?.query?.redirect
        ? this.$route.query.redirect
        : `/${this.modelName}/${this._id}`;
      this.$router.push(redirectUrl);
    },
    $_onSetSomeFieldsValue($event) {
      this.someFieldsValue = $event;
    },
    $_getSomeFieldsKey() {
      this.$_CMS_updateDataSetFromFields(this, this.someFieldsValue, this.someFields);
    },
    async $_fetchData() {
      try {
        if (this.$route.params.id) {
          const res = await this.$axios.get(`/${this.parentModelName}/${this.$route.params.id}`);
          this.parentModelData = res.data.data;
        }
        const params = {
          [`${this.parentModelName}_versions`]: this._parentVersionId,
        };
        const modelVersionData = await this.$axios.get(`/${this.modelName}_version`, { params });
        this.total = modelVersionData.data.meta.total;
      } catch (error) {
        alert(error);
      }
    },
    $_setLocalesData(submitItem) {
      const { content, book, part, chapter, division, section, sub_section, no_text } = submitItem;
      const localesData = {
        content,
        rich_content: content,
        ...(book && { book }),
        ...(part && { part }),
        ...(chapter && { chapter }),
        ...(division && { division }),
        ...(section && { section }),
        ...(sub_section && { sub_section }),
        ...(no_text && { no_text }),
      };
      return localesData;
    },
  },
};
</script>
